<template>
   <swiper class="wrapper" ref="mySwiper" :options="swiperOptions">
    <!-- <swiper-slide>
      <div class="imgBox">
       <img style="width:100%" src="@assets/img/banner03_h5.jpg" />
      </div>
    </swiper-slide> -->
    <swiper-slide>
      <div class="imgBox">
       <img style="width:100%" src="@assets/img/banner_h5.jpg" />
      </div>
    <el-button size="mini" type="warning" class="dowBtn">
      <a href="https://m.shopsbu.com/download/" target="_blank" style="width:100%;height: 100%;color: #fff;">
        {{$t('other.a1736')}}
      </a>
    </el-button>
    </swiper-slide>
    <swiper-slide>
      <div class="imgBox">
         <img style="width:100%" src="@assets/img/banner01_h5.jpg" />
      </div>
    <el-button size="mini" type="warning" class="dowBtn">
      <a href="https://m.shopsbu.com/download/" target="_blank" style="width:100%;height: 100%;color: #fff;">
        {{$t('other.a1736')}}
      </a></el-button>
    </swiper-slide>
   
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
export default {
data(){
return{
    
}
},
create(){

},
methods:{

}
}

</script>
<style lang="scss" scoped>


.wrapper{
    width: 375px;
    border-radius: 10px;
    padding-top:60px ;

    .imgBox{
        width: 100%;
        border-radius: 20px;
    }
}
.dowBtn {
  position: absolute;
  bottom: 0px;
  right: 0px;
}

</style>